import {API_BASE_URL} from "../../../config/constants";
import { postRequest } from '../../API'

/*********************************************************
* Function Name : updateDeviceToken
* Description   : Update device token (FCM token) for notifications
* By            : System
* Date          : 2026-01-XX
*********************************************************/
export const updateDeviceToken = async (deviceId) => {
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/users/update-token`,
            postData : { web_device_id: deviceId }
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage || 'Failed to update device token'}
        }
    } catch (error) {
        console.log('Error updating device token:', error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

